module.exports = __webpack_public_path__ + "Gotham-Light.793441dfbe8ca3932bc4.svg";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Light.svg
// module id = ../../../../../src/assets/fonts/Gotham-Light.svg
// module chunks = 2